import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import {ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  FormBuilder
} from '@angular/forms';
import { SearchComponent } from 'src/app/components/search/search.component';
import SwalAlert from 'src/app/utils/swalalert';
import { BlocksService } from 'src/app/api/report/blocks.service';
import AlertifyHelper from 'src/app/utils/utils';
import { ToolsService } from 'src/app/utils/tools.service';
import { environment } from 'src/app/environment';
declare var $: any;

@Component({
  selector: 'app-blocksagency-detail',
  templateUrl: './blocksagency-detail.component.html',
  styleUrls: ['./blocksagency-detail.component.css']
})
export class BlocksagencyDetailComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  format_excel:any = "excel";

  // arrays
  book: any = null;
  transfers: any = [];
  receiveds: any = [];

   // TOTALES TRASPASOS
   total_transfers: any = 0;
   total_delegated_payment: any = 0;
 
   // TOTALES RECIBIDOS
   total_receiveds = 0;
   total_assigned_payment = 0;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private globalService: GlobalService,
    private blocksService: BlocksService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.editData();
  }

  ngOnInit() {
    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  editData(check_id = null) {
    this.blocksService.blocksAgencyDetail(this.checkId).subscribe({
      next: (data: any) => {
        let result = data;    
        this.book = result.book;
        this.transfers = this.book.detailtransfers_data;        
        this.receiveds = this.book.detailreceiveds_data; 
        this.calculateBalance();       
        console.log(this.transfers);
        console.log(this.receiveds);
      }
    });
  }

  calculateBalance() {
    // transfers total
    this.total_transfers = 0;
    this.total_delegated_payment = 0;
    for (let i in this.transfers) {
      let item = this.transfers[i];
      this.total_transfers =
        this.total_transfers + Number(item.price_corporate * item.quantity);
      this.total_delegated_payment =
        this.total_delegated_payment + Number(item.delegated_payment);
    }

    // receiveds total
    this.total_receiveds = 0;
    this.total_assigned_payment = 0;
    for (let i in this.receiveds) {
      let item = this.receiveds[i];
      this.total_receiveds =
        this.total_receiveds + Number(item.price_corporate * item.quantity);
      this.total_assigned_payment =
        this.total_assigned_payment + Number(item.assigned_payment);
    }
  }

  delete(item: any) {
    let options = {
      title: '¿Estás segur@?',
      message: ' de cuadre N° ' + item.code,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.blocksService.blocksAgencyDelete(item.id, item).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success(
              'El registro de cuadre de hotel ' + item.code + ' se ha eliminado con éxito'
            );
            this.cancel();
          }
        });
      }
    });
  }

  isDebt() {
    let options = {
      title: '¿Estás segur@?',
      message:
        '¿Esta seguro(a) de confirmar la liquidez del cuadre de agencia?. Una vez liquidado ya no se podrá realizar cambios sobre el cuadre realizado',
      cancel: 'Cancelar',
      confirm: 'CONFIRMAR LIQUIDEZ'
    };
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
       this.blocksService.blocksAgencyisDebt(this.book.id, this.book).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success("CONFIRMACIÓN DE LIQUIDEZ realizado con éxito !");
          this.editData(data.data.id);
        }
      });
      }
    });
  }

  printer() {
    (<any>$('#body')).printThis({
      importCSS: true
    });
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reportes/cuadresagencia/lista']);
  }

}
